module.exports = __webpack_public_path__ + "static/media/bobs.4e8c3415.png";